import { Slider } from "@mantine/core";

type RangeSliderProps = {
    value: number;
    min: number;
    max: number;
    onChange: (value: number | number[]) => void;
};

export const RangeSlider = ({ value, min, max, onChange }: RangeSliderProps) => {
    return (
        <Slider
            color="teal"
            label={null}
            max={max || 0}
            min={min}
            onChange={onChange}
            size="sm"
            thumbSize={16}
            value={value}
        />
    );
};
